import httpClient from "@/httpClient"
import AwesomeDebouncePromise from "awesome-debounce-promise"
import { createCancellable } from "@/utils/cancellable"
import { CANCEL_SOURCES } from "@/constants/CANCEL_SOURCES"

const getUsers = ({ params }, forceCompany = '') => {
  return httpClient.get(`${forceCompany || '{currentCompanySlug}'}/company-accounts`,
    {
      params,
    })
}

let mentionUsersCancellable = createCancellable(CANCEL_SOURCES.MENTION_SEARCH)

const getMentionable = (recordId, { params }, company = '') => {
  mentionUsersCancellable.abort()
  mentionUsersCancellable = createCancellable(CANCEL_SOURCES.MENTION_SEARCH)
  return httpClient.get(`${company || '{currentCompanySlug}'}/quotes/${recordId}/mentionable`,
    {
      params,
      ...mentionUsersCancellable.config,
    })
}

export default {
  getUsers: getUsers,
  debouncedGetMentionable: AwesomeDebouncePromise(getMentionable, 1000),
}
